export const DEFAULT_CRYPTO = 'BTC';